<template>
  <v-dialog
      v-model="showLoader"
      persistent
      width="300"
    >
      <v-card>

        <v-toolbar color="#0000001f">
          <v-toolbar-title>
            <v-icon left>mdi-file-check mdi-24px</v-icon>Atenção
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn small icon @click="$emit('close')">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text v-html="message">
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="$emit('close')"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
  name: 'AlertDialog',
  props: ['showLoader', 'message'],
};
</script>




// WEBPACK FOOTER //
// src/components/AlertDialog.vue